/**
 * Which backend is this build pointed at?
 *
 * The dev web apps (hindaun.in) are publicly reachable and look identical to
 * prod, so a user handed that link hits "No account found" — their account
 * lives in the prod database — and reasonably concludes it was deleted. The
 * login screen says which environment it is so that dead end is legible.
 *
 * Decided by the prod API host rather than a dedicated flag: every prod build
 * loads `.env.production`, which pins `VITE_API_BASE` to that host. Anything
 * else — the dev build, a local dev server, an unset base — is not prod. That
 * direction is deliberate: failing to mark dev is the bug we are fixing, while
 * mislabelling prod as dev would be worse than saying nothing.
 */
const PROD_API_HOST = 'aitutor-prod-func';

export function isDevEnvironment(): boolean {
    const base = (import.meta.env?.VITE_API_BASE as string | undefined) ?? '';
    return !base.includes(PROD_API_HOST);
}
